<section>
	<ux-product-visual
		[product]="anamnese.product"
		[isDisplayedDuringOrder]="true"
	></ux-product-visual>

	<div class="options">
		<tm2-anamnese-options-jaws
			*ngIf="currentSubState === OptionsSubstate.JAW_SELECTION"
			[options]="anamnese?.product?.options"
			[productKey]="anamnese?.product?.key">
		</tm2-anamnese-options-jaws>

		@if (currentSubState === OptionsSubstate.JAW_SELECTION && RETENTIONSSCHIENE_PRODUCT_DATA_KEYS.includes(anamnese.product.key)) {
			<mat-checkbox
				[(ngModel)]="is3x2BulkOptionChecked"
				[disabled]="is3x2BulkOptionDisabled()"
				(change)="on3x2BulkOptionToggled($event.checked)"
				data-cy="retentionsschiene-3x2-checkbox">
				{{"Retentionsschiene3x2CheckboxLabel" | translate}}
			</mat-checkbox>
		}

		<tm2-custom-options
			*ngIf="currentSubState === OptionsSubstate.TOOTH_AREA_SELECTION"
			[hasUpperJaw]="anamnese?.product?.options?.uj"
			[hasLowerJaw]="anamnese?.product?.options?.lj"
			(action)="onAction($event)">
		</tm2-custom-options>
	</div>
</section>
@if( showNextBackComponent() ){
	<ux-next-back-actions
		(action)="onAction($event)"
		[disabledNext]="isNextButtonDisabled()"
	></ux-next-back-actions>
}
@if( showNextButtonOnly() ){
	<button mat-raised-button
		class="next-button"
		[disabled]="isNextButtonDisabled()"
		(click)="onAction({type: ACTION.NEXT})"
		color="primary"
	>{{"Next" | translate}}</button>
}
